/**
 * User: herbert
 * Date: 19.04.16
 * Time: 11:07
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';
import T from '../../../../nls/translate.js';

export default React.createClass({
	propTypes: {
		onItemClick: React.PropTypes.func.isRequired,
		selected: React.PropTypes.bool.isRequired,
		o: React.PropTypes.object.isRequired
	},
	_onClick: function() {
		this.props.onItemClick(this.props.o);
	},
	render: function() {
		return (
				<div className={this.props.selected ? 'slx-stele-options__size slx-stele-options__selected' : 'slx-stele-options__size'}
				     onClick={this._onClick}>
					{T.current.PRODUCTS.description[this.props.o.name]}
				</div>
		);
	}
});
